var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8.1992C7 7.07938 7 6.51946 7.21793 6.09175C7.40963 5.71552 7.71552 5.40963 8.09175 5.21793C8.51946 5 9.07938 5 10.1992 5H10.3325V5.6665C10.3325 6.0346 10.6309 6.333 10.999 6.333H13.665C14.0331 6.333 14.3315 6.0346 14.3315 5.6665V5H14.4648C15.5846 5 16.1445 5 16.5723 5.21793C16.9485 5.40963 17.2544 5.71552 17.4461 6.09175C17.664 6.51946 17.664 7.07938 17.664 8.1992V15.1308C17.664 16.2506 17.664 16.8105 17.4461 17.2383C17.2544 17.6145 16.9485 17.9204 16.5723 18.1121C16.1445 18.33 15.5846 18.33 14.4648 18.33H10.1992C9.07938 18.33 8.51946 18.33 8.09175 18.1121C7.71552 17.9204 7.40963 17.6145 7.21793 17.2383C7 16.8105 7 16.2506 7 15.1308V8.1992ZM12.332 15.665C12.7001 15.665 12.9985 15.3666 12.9985 14.9985C12.9985 14.6304 12.7001 14.332 12.332 14.332C11.9639 14.332 11.6655 14.6304 11.6655 14.9985C11.6655 15.3666 11.9639 15.665 12.332 15.665Z",
    fill: "#0A51C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.a1ea556cb2d9ef87de89433cf8a56e09.svg";
export { ForwardRef as ReactComponent };